import * as PopoverPrimitive from "@radix-ui/react-popover";
import PopoverContent from "./components/PopoverContent";
import PopoverIcon from "./components/PopoverIcon";
const Popover = PopoverPrimitive.Root;
const PopoverWithComponents = Object.assign(Popover, {
    Trigger: PopoverPrimitive.Trigger,
    Content: PopoverContent,
    Icon: PopoverIcon,
});
export { PopoverContent, PopoverIcon };
export default PopoverWithComponents;
